/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';

import { AppSkeletonImage } from '../../../common/ui';
import imgSVG from '../assets/filter-results-edit-skeleton.tpl.svg';

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	'&&': {
		border: 'none',
	},
});

const FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';

export const FilterResultsEditSkeleton = () => (
	<AppSkeletonImage
		src={imgSVG}
		css={customCssStyles}
		containerStyles={{ height: FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT }}
	/>
);
